export const wrapper = 'mt-4 min-w-0 flex items-center';
export const buttonIcon = 'h-4 w-4 text-secondary ml-1';
